var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-wrapper',{attrs:{"variant":_vm.avatarVariant,"size":_vm.avatarSize}},[(_vm.src)?_c('s-photo',[_c('img',{attrs:{"src":_vm.src}})]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }